import { render, staticRenderFns } from "./SageConfigurationDialog.vue?vue&type=template&id=6232a833"
import script from "./SageConfigurationDialog.vue?vue&type=script&lang=js"
export * from "./SageConfigurationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports